import React, { FC } from 'react';

import { Container, Typography } from '@mui/material';
import cx from 'classnames';

import { TrustpilotBlock as TrustpilotBlockType } from '../../types';
import { LazyLoadImage } from '../LazyloadImage';
import useStyles from './styles';

interface TrustpilotBlockProps {
  data: TrustpilotBlockType;
}

const TrustpilotBlock: FC<TrustpilotBlockProps> = ({ data }) => {
  const classes = useStyles(data?.background)();

  return (
    <div
      className={cx(
        classes.wrapper,
        data?.background === 'Dark' ? 'dark-block' : 'light-block',
        'trustpilot-block',
      )}
    >
      <Container className={cx(classes.container, 'trustpilot-block__container')}>
        <div className={cx(classes.textWrapper, 'trustpilot-block__text-wrap')}>
          {data?.trustpilot_url ? (
            <a
              href={data.trustpilot_url}
              className={cx(classes.titleLink, 'trustpilot-block__title-link')}
            >
              <Typography variant="h2" className={cx(classes.title, 'trustpilot-block__title')}>
                {data?.title}
              </Typography>
            </a>
          ) : (
            <Typography variant="h2" className={cx(classes.title, 'trustpilot-block__title')}>
              {data?.title}
            </Typography>
          )}
          <Typography className={cx(classes.description, 'trustpilot-block__description')}>
            {data?.description}
          </Typography>
        </div>
        <div className={cx(classes.imgWrapper, 'trustpilot-block__img-wrap')}>
          {data?.trustpilot_image &&
            (data?.trustpilot_url ? (
              <a href={data.trustpilot_url}>
                <LazyLoadImage
                  path={data.trustpilot_image}
                  className={cx(classes.img, 'trustpilot-block__img')}
                />
              </a>
            ) : (
              <LazyLoadImage
                path={data.trustpilot_image}
                className={cx(classes.img, 'trustpilot-block__img')}
              />
            ))}
        </div>
      </Container>
    </div>
  );
};

export default TrustpilotBlock;
